var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-tabbar',{attrs:{"route":""}},[_c('van-tabbar-item',{attrs:{"replace":"","to":"/home","icon":"home-o"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"replace":"","to":"/query","icon":"search"}},[_vm._v("查询结果")])],1),_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }